import template from './estates-trashbin.pug';

export const EstatesTrashbinComponent = {
  template,
  bindings: {
    filter: '<',
    onFilterChange: '&',
    onPageChange: '&',
  },
  controller: class EstatesTrashbinComponent {
    constructor(Estate, $log, $async,$stateParams ) {
      'ngInject';
      this.Estate = Estate;
      this.$stateParams = $stateParams;
      this.$log = $log;
      this.getEstates = $async(this.getEstates.bind(this));
      this.checkedIds = [];
      this.gridOptions = this.Estate.gridOptions();
    }

    $onChanges(changesObj) {
      if (changesObj.filter && !(changesObj.filter.length === 0)) {
        this.getEstates();
      }
    }

    $onInit() {
    }

    async getEstates() {
      this.filter.only_deleted = true;
      try {
        this.loader = true;
        let searchId = this.filter.searchId || -1;
        const { data, meta } = await this.Estate.getListBySearchId(searchId,this.filter);
        this.records = data;
        this.gridOptions.data = data.map( elm => elm.attributes);
        this.totalCount = meta.count;
        this.totalPages = meta.pages;
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.loader = false;
      }
    }

    applyFilter({ filter }) {
      this.filter = { ...this.filter, ...filter };
      this.onFilterChange({ $event: { filter } });
    }

    recoveredEstates() {
      this.getEstates();
    }

    checkedContacts({ checkedIds }) {
      this.checkedIds = checkedIds;
    }

    updatePage(page) {
      this.filter = { ...this.filter, ...page };
      this.onPageChange({ $event: page });
    }

  }
};
